var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5674 7.15035V12.8503C17.5674 13.7837 17.0674 14.6504 16.2591 15.1254L11.3091 17.9837C10.5008 18.4504 9.50078 18.4504 8.68411 17.9837L3.73411 15.1254C2.92578 14.6587 2.42578 13.792 2.42578 12.8503V7.15035C2.42578 6.21702 2.92578 5.35032 3.73411 4.87532L8.68411 2.01699C9.49245 1.55033 10.4924 1.55033 11.3091 2.01699L16.2591 4.87532C17.0674 5.35032 17.5674 6.20869 17.5674 7.15035Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 9.16651C11.0726 9.16651 11.9419 8.29719 11.9419 7.22483C11.9419 6.15248 11.0726 5.2832 10.0003 5.2832C8.92791 5.2832 8.05859 6.15248 8.05859 7.22483C8.05859 8.29719 8.92791 9.16651 10.0003 9.16651Z",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 13.8836C13.3327 12.3836 11.841 11.167 9.99935 11.167C8.15768 11.167 6.66602 12.3836 6.66602 13.8836",
    stroke: "#322972",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLogin);
export default __webpack_public_path__ + "static/media/user-login.155512270a0456707afcafbdf13a8e4f.svg";
export { ForwardRef as ReactComponent };